<div class="flex flex-col items-center">
  <div class="mb-2">
    <i class="pi pi-exclamation-circle bg-grey-200 p-3 rounded-full"></i>
  </div>
  <div class="text-center mb-6">
    <p class="font-bold text-xl text-grey-700 pb-2 md:text-2xl">{{ 'notFound.title' | transloco }}</p>
    <p class="text-grey-700 text-[15px]">{{ 'notFound.body' | transloco }}</p>
  </div>
  <a routerLink="/" class="bg-jcb font-bold text-grey-800 px-6 py-2 rounded-md">{{ 'notFound.goToDashboard' | transloco }}</a>
</div>
